import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kartni izstrelek",
  "description": "",
  "published": "2007-04-03T00:00:00.000Z",
  "redirect_from": ["/blog/kartni-izstrelek/swizec/244"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`VÄeraj me je prijelo, da bi se nauÄil metati karte in tako sem se odpravil na širni internet v iskanju informacij o tem, ker, kot vsi vemo, na internetu je vse. Moram reÄi, da sem se v dejanje zaljubil, Äeprav sem komaj sposoben vreÄi karto s kakršnokoli hitrostjo kaj šele natanÄnostjo. Še vedno je zabavno in priporoÄam vsakomur kot antistresor.`}</p>
    <p>{`Obstajajo mojstri te umetnosti, ki jih najverjetneje nikoli ne bom dosegel v spretnosti in doseÅ¾kih. Eden takih je neverjetni `}<a parentName="p" {...{
        "href": "http://www.rickyjay.com/"
      }}>{`Ricky Jay`}</a>{`. ÄŒlovek je preprosto izjemen in svetujem vam, da se spravite na youtube pogledat kaj njegovih filmÄkov - garantirano boste `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=HFAzKv8_XF4"
      }}>{`presunjen`}</a>{`i.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      